// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-form__inputs-wrapper[data-v-25c686c5]{display:flex;flex-wrap:wrap;align-items:flex-end;gap:12px 16px;width:100%}@media(min-width:1264px){.search-form__inputs-wrapper[data-v-25c686c5]{flex-wrap:nowrap}}.search-form__inputs-wrapper>.entra-filter-col[data-v-25c686c5]{flex:1 1 0;min-width:150px;max-width:260px;margin:0;padding:0}[data-v-25c686c5] .v-list-item{text-align:left}[data-v-25c686c5] .theme--light.v-list-item--active{background-color:rgba(238,165,7,.2)}", ""]);
// Exports
module.exports = exports;
